module.exports = __webpack_public_path__ + "static/media/team.f8d1bc69.png";